// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactions-picker-wrapper[data-v-0bce4b8c] {
  position: absolute;
  transition: all 0.5s;
  z-index: 9999;
  margin-right: 2px;
  margin-bottom: -4px;
}
.reactions-picker-wrapper .reaction-popup[data-v-0bce4b8c] {
  transition: all 0.25s;
  display: flex;
  align-items: center;
  font-size: 1.8rem;
}
.reactions-picker-wrapper .reaction-popup .reaction-icon[data-v-0bce4b8c] {
  transition: all 0.25s;
  display: flex;
  align-items: end;
  justify-content: center;
  background-color: transparent;
  height: 2rem;
  width: 2rem;
}
.reactions-picker-wrapper .reaction-popup .reaction-icon.left[data-v-0bce4b8c] {
  align-items: end;
  justify-content: center;
  margin-left: 3px;
}
.reactions-picker-wrapper .reaction-popup .reaction-icon .reaction-icon-emoji[data-v-0bce4b8c] {
  font-size: 1em;
  color: var(--reactions-picker-icon);
}
.reactions-picker-wrapper .reaction-popup .reaction-toolbar[data-v-0bce4b8c] {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--reactions-items-toolbox-bgcolor);
  border-radius: 1.6em;
  width: 13.6em;
  z-index: 999;
  justify-content: space-evenly;
  height: 2.2em;
  padding-left: 3px;
}
.reactions-picker-wrapper .reaction-popup:hover .reaction-toolbar .reaction-item[data-v-0bce4b8c] {
  transition: all 0.25s;
}
.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper[data-v-0bce4b8c] {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 3px;
}
.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item[data-v-0bce4b8c] {
  cursor: pointer;
  margin-bottom: -1px;
}
.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item.last[data-v-0bce4b8c] {
  font-size: 2.55rem;
  margin-bottom: 0px;
  margin-left: 4px;
  margin-right: 4px;
  color: white;
  border-radius: 1em;
  background-color: transparent;
}
.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item.last[data-v-0bce4b8c]:hover {
  transform: scale(1.25) translateY(-1px);
  backdrop-filter: brightness(0.5);
}
.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item[data-v-0bce4b8c]:not(.last):hover {
  transform: scale(1.3);
  background-color: transparent;
  border-radius: 1em;
}
.fade-enter-active[data-v-0bce4b8c],
.fade-leave-active[data-v-0bce4b8c] {
  transition: opacity 0.35s ease;
}
.fade-enter-from[data-v-0bce4b8c],
.fade-leave-to[data-v-0bce4b8c] {
  opacity: 0;
}
.toolbox-enter-active[data-v-0bce4b8c],
.toolbox-leave-active[data-v-0bce4b8c] {
  transition: opacity 0.5s ease;
}
.toolbox-enter-from[data-v-0bce4b8c],
.toolbox-leave-to[data-v-0bce4b8c] {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/reactions/ReactionsPicker.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,UAAU;AACZ","sourcesContent":[".reactions-picker-wrapper[data-v-0bce4b8c] {\n  position: absolute;\n  transition: all 0.5s;\n  z-index: 9999;\n  margin-right: 2px;\n  margin-bottom: -4px;\n}\n.reactions-picker-wrapper .reaction-popup[data-v-0bce4b8c] {\n  transition: all 0.25s;\n  display: flex;\n  align-items: center;\n  font-size: 1.8rem;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-icon[data-v-0bce4b8c] {\n  transition: all 0.25s;\n  display: flex;\n  align-items: end;\n  justify-content: center;\n  background-color: transparent;\n  height: 2rem;\n  width: 2rem;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-icon.left[data-v-0bce4b8c] {\n  align-items: end;\n  justify-content: center;\n  margin-left: 3px;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-icon .reaction-icon-emoji[data-v-0bce4b8c] {\n  font-size: 1em;\n  color: var(--reactions-picker-icon);\n}\n.reactions-picker-wrapper .reaction-popup .reaction-toolbar[data-v-0bce4b8c] {\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--reactions-items-toolbox-bgcolor);\n  border-radius: 1.6em;\n  width: 13.6em;\n  z-index: 999;\n  justify-content: space-evenly;\n  height: 2.2em;\n  padding-left: 3px;\n}\n.reactions-picker-wrapper .reaction-popup:hover .reaction-toolbar .reaction-item[data-v-0bce4b8c] {\n  transition: all 0.25s;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper[data-v-0bce4b8c] {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 3px;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item[data-v-0bce4b8c] {\n  cursor: pointer;\n  margin-bottom: -1px;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item.last[data-v-0bce4b8c] {\n  font-size: 2.55rem;\n  margin-bottom: 0px;\n  margin-left: 4px;\n  margin-right: 4px;\n  color: white;\n  border-radius: 1em;\n  background-color: transparent;\n}\n.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item.last[data-v-0bce4b8c]:hover {\n  transform: scale(1.25) translateY(-1px);\n  backdrop-filter: brightness(0.5);\n}\n.reactions-picker-wrapper .reaction-popup .reaction-item-wrapper .reaction-item[data-v-0bce4b8c]:not(.last):hover {\n  transform: scale(1.3);\n  background-color: transparent;\n  border-radius: 1em;\n}\n.fade-enter-active[data-v-0bce4b8c],\n.fade-leave-active[data-v-0bce4b8c] {\n  transition: opacity 0.35s ease;\n}\n.fade-enter-from[data-v-0bce4b8c],\n.fade-leave-to[data-v-0bce4b8c] {\n  opacity: 0;\n}\n.toolbox-enter-active[data-v-0bce4b8c],\n.toolbox-leave-active[data-v-0bce4b8c] {\n  transition: opacity 0.5s ease;\n}\n.toolbox-enter-from[data-v-0bce4b8c],\n.toolbox-leave-to[data-v-0bce4b8c] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
